import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone, Sparkles } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            data-testid="brand-logo"
            className="flex items-center gap-3 group"
          >
            <img src="/LogoAnusha.png" alt="Dr. Anusha Mandava Logo" className="h-12 w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-6 xl:gap-7" aria-label="Primary">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${
                    isActive
                      ? "text-blue-800"
                      : "text-slate-600 hover:text-blue-800"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => navigate("/contact")}
              data-testid="header-consult-btn"
              className="inline-flex items-center gap-2 bg-blue-900 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-blue-800 transition-colors whitespace-nowrap"
            >
              Consult Dr. Anusha
              <span aria-hidden>→</span>
            </button>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 -mr-2 text-slate-700"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div
            data-testid="mobile-nav"
            className="lg:hidden pb-6 pt-2 border-t border-slate-100"
          >
            <div className="flex flex-col gap-1">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `py-3 px-2 text-base font-medium border-b border-slate-50 ${
                      isActive ? "text-blue-800" : "text-slate-700"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
              <div className="mt-4 flex gap-3">
                <a
                  href={`tel:${SITE.phoneRaw}`}
                  className="flex-1 inline-flex items-center justify-center gap-2 text-sm font-semibold border border-slate-200 rounded-full px-4 py-3"
                >
                  <Phone className="h-4 w-4" /> Call
                </a>
                <Link
                  to="/contact"
                  onClick={() => setOpen(false)}
                  className="flex-1 inline-flex items-center justify-center bg-blue-900 text-white text-sm font-semibold rounded-full px-4 py-3"
                >
                  Book Consultation
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
